import React from 'react'
import className from 'classnames/bind'

import style from './MyhousePricePage.module.scss'

import MyhousePriceSource from '@Components/atoms/MyhousePriceSource'
import MyhouseTrendPrice from '@Components/modules/MyhouseTrendPrice'
import MyhouseRealPrice from '@Components/modules/MyhouseRealPrice'
import MyhousePriceTradeType from '@Components/atoms/MyhousePriceTradeType'
import { TRADE } from '@Root/contants'

const cx = className.bind(style)

type Props = {
  setTradeType: (tradeType: TRADE) => void
  setPeriod: (period: number) => void
  price: any
  tradeTypeCurrentTab: any
}

const MyhousePricePage: React.FC<Props> = ({ price, setTradeType, setPeriod, tradeTypeCurrentTab }: Props) => {
  const { real, tradeType, summary, chart, period } = price

  return (
    <div id="myhouse_price" className={cx('article')}>
      <div className={cx('title')}>
        <h2 className={cx('text')}>시세/실거래가</h2>
        <MyhousePriceSource provider={summary.provider} price={price} tradeTypeCurrentTab={tradeTypeCurrentTab} />
      </div>
      <MyhousePriceTradeType setTradeType={setTradeType} tradeType={tradeType as TRADE} />
      <MyhouseTrendPrice chart={chart} period={period} summary={summary} tradeType={tradeType} setPeriod={setPeriod} />
      <MyhouseRealPrice real={real} tradeType={tradeType} />
    </div>
  )
}

export default MyhousePricePage
